module.exports = __webpack_public_path__ + "static/media/hover_image_button2.9e051c36.png";